
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Register the components you want to use
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const ClientDashboardChart = ({border_color="#9747ff",graph_data}) => {

    const data =  {
        // labels: ['oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
        labels:graph_data?.labels? graph_data?.labels:[],
        datasets: [{
            //   label: '',
             data:graph_data?.impressions?graph_data?.impressions:[],
            // data:[],
             backgroundColor:"#fbf6ff",
             borderColor:border_color,
             fill:true,
             
            borderWidth: 1
        }]
    }

    const options = {
        scales: {
            y: {
                beginAtZero: true,
                display:true
            },
            x: {
                grid:{
                    display:false,
                    drawBorder:true
                }
            },
            
        },
        plugins: {
            legend: {
                display: false // Hide the legend
            }
        }

    }





    return <Line data={data} options={options}  height={'60%'} />;
};

export default ClientDashboardChart;
